import { getTabId } from '@/utils/tab-id';

export const storeName = 'blt-checkout-storage';

const localStorageMiddleware =
  (items) =>
  ({ getState }) =>
  (next) =>
  (action) => {
    const result = next(action);
    const currentItem = action.type.split('/')[0];
    if (items.includes(currentItem)) {
      const tabId = getTabId('set state');
      const localState =
        JSON.parse(localStorage.getItem(`${storeName}-${tabId}`)) || {};
      const state = getState()[currentItem];
      localStorage.setItem(
        `${storeName}-${tabId}`,
        JSON.stringify({
          ...localState,
          [currentItem]: state,
        }),
      );
    }
    return result;
  };

const reHydrateStore = (item) => {
  if (typeof window !== 'undefined') {
    const tabId = getTabId('rehydrate state');
    const localState =
      JSON.parse(localStorage.getItem(`${storeName}-${tabId}`)) || {};
    return localState[item];
  }
  return null;
};

/**
 * This function retrieves the raw local storage value, and add a message if is passed as param.
 * @param {string} message - The message to add to the returned local storage value
 * @returns {string|null} - The value of the property or null if not found.
 */
const getLocal = (message) => {
  if (typeof window !== 'undefined') {
    const tabId = getTabId('parse local');

    const local = localStorage.getItem(`${storeName}-${tabId}`);

    if (message) {
      const parsedLocal = JSON.parse(local);
      parsedLocal.message = message;
      return JSON.stringify(parsedLocal);
    }

    return local;
  }
};

export { localStorageMiddleware, reHydrateStore, getLocal };
